import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import sentImg from '../../../assets/images/confirmation_sent.png';
import { analyticsTrack } from '../../analyticsUtils';
import './EmptyFeaturedProfiles.scss';
var EmptyFeaturedProfiles = /*#__PURE__*/function (_Component) {
  function EmptyFeaturedProfiles(props) {
    var _this;
    _classCallCheck(this, EmptyFeaturedProfiles);
    _this = _callSuper(this, EmptyFeaturedProfiles, [props]);
    _this.state = {
      emailSent: false
    };
    _this.handleAnalytics = _this.handleAnalytics.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    return _this;
  }
  _inherits(EmptyFeaturedProfiles, _Component);
  return _createClass(EmptyFeaturedProfiles, [{
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      var value = target.value;
      var name = target.name;
      this.setState(_defineProperty({
        valid: target.validity.valid
      }, name, value));
    }
  }, {
    key: "handleAnalytics",
    value: function handleAnalytics() {
      this.setState({
        emailSent: true
      });
      analyticsTrack('Clicked on Reach Out', {
        location: 'Featured Consultants'
      });
    }
  }, {
    key: "renderConnectButton",
    value: function renderConnectButton() {
      var _this$props = this.props,
        userData = _this$props.userData,
        filters = _this$props.filters;
      var baseLink = 'https://clora.na.chilipiper.com/book/search';
      if (userData) {
        baseLink += "?firstname=".concat(userData.first_name, "&lastname=").concat(userData.last_name, "&email=").concat(userData.email);
        if (userData.company_name) {
          baseLink += "&current_last_company_name__c=".concat(userData.company_name);
        }
      }
      if (Object.keys(filters).length) {
        baseLink += "".concat(userData ? '&' : '?', "sales_intake_description__c=");
        if (filters.aoe) {
          baseLink += "AOE-".concat(filters.aoe);
        }
        if (filters.ta) {
          baseLink += "  TA-".concat(filters.ta);
        }
        if (filters.therapy) {
          baseLink += "  THERAPY-".concat(filters.therapy);
        }
      }
      return /*#__PURE__*/React.createElement(Button, {
        type: "submit",
        name: "commit",
        id: "connect-employer-submit-btn",
        tabIndex: "0",
        href: encodeURI(baseLink),
        target: "_blank",
        onClick: this.handleAnalytics
      }, "Reach out to us!");
    }
  }, {
    key: "render",
    value: function render() {
      var searchError = this.props.searchError;
      var emailSent = this.state.emailSent;
      if (emailSent) {
        return /*#__PURE__*/React.createElement("div", {
          className: "empty-featured-profiles emailSent"
        }, /*#__PURE__*/React.createElement("img", {
          src: sentImg,
          className: "email-sent-image",
          alt: "email sent"
        }), /*#__PURE__*/React.createElement("h1", {
          className: "bold muted-gray-text"
        }, "Thank you! Clora will contact you shortly!"));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "empty-featured-profiles"
      }, searchError ? /*#__PURE__*/React.createElement("p", {
        className: "body-text-1 error-text"
      }, searchError) : '', /*#__PURE__*/React.createElement("h2", {
        className: "bold"
      }, "Clora has thousands more consultants in the network!"), /*#__PURE__*/React.createElement("p", {
        className: "body-text-1"
      }, "Looks like you haven\u2019t found what you\u2019re looking for yet."), /*#__PURE__*/React.createElement("p", {
        className: "body-text-1"
      }, "Connect with our team and we will help you find the right consultant for your project!"), this.renderConnectButton());
    }
  }]);
}(Component);
EmptyFeaturedProfiles.propTypes = {
  filters: PropTypes.shape({}),
  searchError: PropTypes.string,
  userData: PropTypes.shape({})
};
EmptyFeaturedProfiles.defaultProps = {
  filters: {},
  userData: null,
  searchError: null
};
export default EmptyFeaturedProfiles;